export default __webpack_public_path__ + "static/media/csv-icon.7d902e0b.svg";